import React from 'react'
import hback from '../Image/hback.jpg'
import { FaGraduationCap } from "react-icons/fa";
import Fade from 'react-reveal/Fade'
import TypeWriter from '../Page/TypeWriter'
import { PiBagBold } from "react-icons/pi";
import { TiInputCheckedOutline } from "react-icons/ti";
const typeWriter = [
  'Data Science',
  'Machine Learning',
  'Web Development',
  'Java',
  'Cloud Computing',
]
function Home_page() {
  return (
    <div>
      {/* ------------------------Mobile View--------------------------------- */}
      <div className="container_fluid  d-sm-block d-md-none pb-4 pt-5 mt-4">
        <div className="container-fluid">
          <div className="row">
            <Fade left>
              <div className="col-md-12 pt-5">
                <div className="home_page_text_mobile">
                  <h1 className="">Transform Your Future With InternsElite</h1>
                  <h2 className="pt-2">Whether its <TypeWriter data={typeWriter} />
                  </h2>
                  <div className="home_border mb-2"></div>
                  <p className="">
                    We offer modern training that can help you improve your
                    abilities and open doors to exciting new possibilities. It's
                    time to start feeding your success.{' '}
                  </p>
                </div>
              </div>
            </Fade>
            <div className="col-md-12 mt-3">
              <img
                className="mobile_home_background_img"
                src={hback}
                alt="Abstract displaying the learning pattern at InternsElite"
                title="Abstract displaying the learning pattern at InternsElite"
              />
            </div>
          </div>
        </div>
      </div>

      {/* -----------------------Desktop View--------------------------------- */}
      <div className="container_fluid main_background d-none d-md-block pt-5">
        <div className="container">
          <div className="row pt-4">
            <Fade left>
              <div className="col-md-6  pt-4 mt-5 home_page_text">
                <h1 className="display-5 pt-5">Transform Your<br></br>Future With InternsElite</h1>
                <h2 className="py-2">Whether its <TypeWriter data={typeWriter} /></h2>
                <div className="home_border mb-4"></div>
                <p className="home_pera_text">
                  We offer modern training that can help you improve your
                  abilities and open doors to exciting new possibilities. It's
                  time to start feeding your success.{' '}
                </p>
                <div className='row pt-4 home_page_point'>
                <div className='col-3'><h6 className=''><FaGraduationCap size="35px" color='#FFFF00' />{' '}Get Skilled</h6></div>
                  <div className='col-5 px-5'><h6 className=''><TiInputCheckedOutline size="35px" color='#FF7F3E' />{' '}Get Experienced</h6></div>
                  <div className='col-4'><h6 className=''><PiBagBold size="35px" color='#DA7297' />{' '}Get Hired</h6></div>
                </div>
              </div>
            </Fade>
            <Fade right>
              <div className="col-md-6 pt-5 d-flex justify-content-center">
                <img
                  className="home_background_img pt-3"
                  src={hback}
                  alt="Abstract displaying the learning pattern at InternsElite"
                  title="Abstract displaying the learning pattern at InternsElite"
                />
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home_page
